import { useTheme } from 'next-themes'
import { Sun, Moon, Monitor } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useTranslation } from '@/i18n'

const themes = [
  { id: 'light', icon: Sun, labelKey: 'common:settings.appearance.light' },
  { id: 'dark', icon: Moon, labelKey: 'common:settings.appearance.dark' },
  { id: 'system', icon: Monitor, labelKey: 'common:settings.appearance.system' },
] as const

export default function AppearanceSettings() {
  const { theme, setTheme } = useTheme()
  const { t } = useTranslation()

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-medium">
          {t('common:settings.appearance.theme')}
        </h3>
        <p className="text-sm text-gray-500 dark:text-dark-text-muted">
          {t('common:settings.appearance.theme_description')}
        </p>
      </div>
      <div className="grid grid-cols-3 gap-3 max-w-md">
        {themes.map(({ id, icon: Icon, labelKey }) => (
          <button
            key={id}
            onClick={() => setTheme(id)}
            className={cn(
              'flex flex-col items-center gap-2 rounded-lg border-2 p-4 transition-all',
              theme === id
                ? 'border-purple-500 bg-purple-50 dark:bg-purple-900/20'
                : 'border-gray-200 dark:border-dark-border hover:bg-gray-50 dark:hover:bg-dark-muted bg-white dark:bg-dark-card'
            )}
          >
            <Icon className={cn(
              'h-6 w-6',
              theme === id
                ? 'text-purple-600 dark:text-purple-400'
                : 'text-gray-500 dark:text-dark-text-muted'
            )} />
            <span className={cn(
              'text-sm font-medium',
              theme === id
                ? 'text-purple-700 dark:text-purple-300'
                : 'text-gray-700 dark:text-dark-text'
            )}>
              {t(labelKey)}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
